import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TextField,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Chip,
  Divider,
  Stack,
  Tooltip,
} from "@mui/material";

import axios from "axios";
import BASE_URL from "../../BaseUrl.jsx";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseIcon from "@mui/icons-material/Close";
import PollIcon from "@mui/icons-material/Poll";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import AddIcon from '@mui/icons-material/Add';

const PollsPage = () => {
  const [selectedPoll, setSelectedPoll] = useState(null);
  const [localPolls, setLocalPolls] = useState([]);
  const [message, setMessage] = useState("error message");
  const [showMessage, setShowMessage] = useState(false);
  const [openAddPoll, setOpenAddPoll] = useState(false);
  const [choices, setChoices] = useState([]);
  const [poll , setPoll] = useState({
    id: "",
    name: "",
    question: "",
    choiceOne: "",
    choiceTwo: "",
    choiceThree: "",
    choiceFour: "",
    data: null
  });

  const fetchPolls = async () => {
    try{
      const response = await axios.get(`${BASE_URL}/owner/polls`, { withCredentials: true });
      console.log("Fetched polls:", response.data);
      setLocalPolls(response.data);
    } catch (error) {
      console.error("Error fetching polls:", error);
    }
  };
  function handlePollFetching(data){
    for (let i = 0; i < data.length; i+=4) {
      const poll = {
        id: data[i].id,
        name: data[i].name,
        question: data[i].question,
        choiceOne: {value:data[i].choiceOne},
        choiceTwo: {value:data[i].choiceTwo},
        choiceThree: {value:data[i].choiceThree},
        choiceFour: {value:data[i].choiceFour},
        date: data[i].date
      };
      for(let j = i; j < i + 4 && j < data.length; j++){
        switch(data[j].student_choice){
          case data[i].choiceOne:
            poll.choiceOne.count = data[j].count;
            break;
          case data[i].choiceTwo:
            poll.choiceTwo.count = data[j].count;
            break;
          case data[i].choiceThree:
            poll.choiceThree.count = data[j].count;
            break;
          case data[i].choiceFour:
            poll.choiceFour.count = data[j].count;
            break;
        }
      }
      setLocalPolls((prev) => [...prev, poll]);
    }
  }
  async function newPoll (){
    try{
      const response = await axios.post(`${BASE_URL}/owner/new-poll`,poll, { withCredentials: true })
      setMessage(response.data);
      setOpenAddPoll(false);
      setShowMessage(true);
      setPoll({
        id: "",
        name: "",
        question: "",
        choiceOne: "",
        choiceTwo: "",
        choiceThree: "",
        choiceFour: "",
        data: null
      });
    } catch (error) {
      console.error("Error creating poll:", error);
    }
  }


  async function onDelete(id){
    try{
      const response = await axios.delete(`${BASE_URL}/owner/delete-poll?id=${id}`, { withCredentials: true })
      setMessage(response.data);
      setShowMessage(true);
  }catch (error) {
      console.error("Error deleting poll:", error);
    }
  }

  // Update local polls when props change
  React.useEffect(() => {
    fetchPolls();
  }, []);

  // Open poll details
  const handleOpenPoll = (poll) => {
    setSelectedPoll(poll);
    setChoices([
      { value: poll.choice_one, count: poll.choice_one_votes },
      { value: poll.choice_two, count: poll.choice_two_votes },
      { value: poll.choice_three, count: poll.choice_three_votes },
      { value: poll.choice_four, count: poll.choice_four_votes },
    ]);
  };

  // Close popup
  const handleClosePoll = () => {
    setSelectedPoll(null);
    setChoices([]);
  };

  const handlePollChange = (e) => {
  const { name, value } = e.target;

  setPoll((prev) => ({
    ...prev,
    [name]: value,
  }));
};

  // Delete poll
  const handleDelete = async (e, id) => {
    e.stopPropagation();

    if (!window.confirm("هل أنت متأكد من حذف هذا الاستطلاع؟")) {
      return;
    }

    try {
      onDelete(id);

      setLocalPolls((prev) => prev.filter((poll) => poll.id !== id));

      if (selectedPoll?.id === id) {
        setSelectedPoll(null);
      }
    } catch (error) {
      console.error("Error deleting poll:", error);
    }
  };

  // const choices = selectedPoll
  //   ? [
  //       selectedPoll.choiceOne,
  //       selectedPoll.choiceTwo,
  //       selectedPoll.choiceThree,
  //       selectedPoll.choiceFour,
  //     ]
  //   : [];

  return (
    <Box
      dir="rtl"
      sx={{
        p: { xs: 2, md: 4 },
        minHeight: "100vh",
        bgcolor: "background.default",
      }}
    >
      {/* ================= Header ================= */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 4,
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{ mb: 1 }}
          >
            الاستطلاعات
          </Typography>

          <Typography color="text.secondary">
            إدارة الاستطلاعات وعرض الأسئلة والاختيارات
          </Typography>
        </Box>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setOpenAddPoll(true)}
          sx={{ mb: 3 }}
        >
          إضافة استطلاع جديد
        </Button>

        <Chip
          icon={<PollIcon />}
          label={`${localPolls.length} استطلاع`}
          color="primary"
          variant="outlined"
          sx={{ fontSize: 14, p: 1 }}
        />
      </Box>

      {/* ================= Polls Table ================= */}
      <Paper
        elevation={2}
        sx={{
          borderRadius: 3,
          overflow: "hidden",
        }}
      >
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  bgcolor: "action.hover",
                }}
              >
                <TableCell align="right" sx={{ fontWeight: "bold" }}>
                  اسم الاستطلاع
                </TableCell>

                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  الإجراءات
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {localPolls.length > 0 ? (
                localPolls.map((poll) => (
                  <TableRow
                    key={poll.id}
                    hover
                    onClick={() => handleOpenPoll(poll)}
                    sx={{
                      cursor: "pointer",
                      "&:hover": {
                        bgcolor: "action.hover",
                      },
                    }}
                  >
                    <TableCell align="right">
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1.5}
                      >
                        <PollIcon color="primary" />

                        <Typography fontWeight={600}>
                          {poll.name}
                        </Typography>
                      </Stack>
                    </TableCell>

                    <TableCell align="center">
                      <Tooltip title="حذف الاستطلاع">
                        <IconButton
                          color="error"
                          onClick={(e) => handleDelete(e, poll.id)}
                        >
                          <DeleteOutlineIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={2} align="center">
                    <Box sx={{ py: 6 }}>
                      <PollIcon
                        sx={{
                          fontSize: 50,
                          color: "text.disabled",
                          mb: 1,
                        }}
                      />

                      <Typography color="text.secondary">
                        لا توجد استطلاعات حالياً
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* ================= Poll Details Popup ================= */}
      <Dialog
        open={Boolean(selectedPoll)}
        onClose={handleClosePoll}
        fullWidth
        maxWidth="sm"
        dir="rtl"
        PaperProps={{
          sx: {
            borderRadius: 3,
          },
        }}
      >
        {selectedPoll && (
          <>
            <DialogTitle
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                fontWeight: "bold",
              }}
            >
              تفاصيل الاستطلاع

              <IconButton onClick={handleClosePoll}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>

            <Divider />

            <DialogContent>
              {/* Poll Name */}
              <Box sx={{ mb: 3 }}>
                <Typography
                  color="text.secondary"
                  variant="body2"
                  sx={{ mb: 1 }}
                >
                  اسم الاستطلاع
                </Typography>

                <Typography variant="h6" fontWeight="bold">
                  {selectedPoll.name}
                </Typography>
              </Box>

              {/* Question */}
              <Box sx={{ mb: 3 }}>
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={1}
                  sx={{ mb: 1 }}
                >
                  <HelpOutlineIcon color="primary" />

                  <Typography fontWeight="bold">
                    السؤال
                  </Typography>
                </Stack>

                <Paper
                  variant="outlined"
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    bgcolor: "action.hover",
                  }}
                >
                  <Typography>
                    {selectedPoll.question}
                  </Typography>
                </Paper>
              </Box>

              {/* Choices */}
              <Typography fontWeight="bold" sx={{ mb: 2 }}>
                الاختيارات
              </Typography>

              <Stack spacing={1.5}>
                {choices.map((choice, index) => (
                  console.log(choices),
                  <Paper
                    key={index}
                    variant="outlined"
                    sx={{
                      p: 1.5,
                      borderRadius: 2,
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                    }}
                  >
                    <Chip
                      label={choice.count || 0}
                      color="primary"
                      size="small"
                      sx={{
                        fontWeight: "bold",
                        minWidth: 35,
                      }}
                    />

                    <Typography>
                      {choice.value || "لا يوجد اختيار"}
                    </Typography>
                  </Paper>
                ))}
              </Stack>
            </DialogContent>

            <Divider />

            <DialogActions sx={{ p: 2 }}>
              <Button
                variant="contained"
                onClick={handleClosePoll}
              >
                إغلاق
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>

      <Dialog
          open={openAddPoll}
          onClose={() => setOpenAddPoll(false)}
          dir="rtl"
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>إضافة استطلاع جديد</DialogTitle>

          <DialogContent dir="rtl">
              <TextField
                fullWidth
                label="اسم الاستطلاع"
                name="name"
                value={poll.name}
                onChange={handlePollChange}
                margin="normal"
              />

              <TextField
                fullWidth
                label="السؤال"
                name="question"
                value={poll.question}
                onChange={handlePollChange}
                margin="normal"
                multiline
                rows={2}
              />

              <Divider sx={{ my: 2 }} />

              <Typography variant="subtitle1" fontWeight="bold">
                الاختيارات
              </Typography>

              {[
                { name: "choiceOne", label: "الاختيار الأول" },
                { name: "choiceTwo", label: "الاختيار الثاني" },
                { name: "choiceThree", label: "الاختيار الثالث" },
                { name: "choiceFour", label: "الاختيار الرابع" },
              ].map((choice) => (
                <TextField
                  key={choice.name}
                  fullWidth
                  label={choice.label}
                  name={choice.name}
                  value={poll[choice.name]}
                  onChange={handlePollChange}
                  margin="normal"
                />
              ))}
            </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenAddPoll(false)}>
              إلغاء
            </Button>

            <Button variant="contained" onClick={newPoll}>
              إضافة
            </Button>
          </DialogActions>
        </Dialog>
      { showMessage && (
                <div className="overlay">
                    <div className="home-owner-message">
                        <p>{message}</p>
                        <button onClick={() => setShowMessage(false)}>Close</button>
                    </div>
                </div>
            )}
    </Box>
  );
};

export default PollsPage;